/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  LIVE_ORDER_API_REQUEST,
  LIVE_ORDER_API_SUCCESS,
  LIVE_ORDER_API_FAILURE,
} from '../constants/ActionTypes';

const selected = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case LIVE_ORDER_API_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case LIVE_ORDER_API_SUCCESS:
      const { data: dataOrderAPISuccess } = state;
      dataOrderAPISuccess.order_api = 'RUNNING';
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataOrderAPISuccess,
      };
    case LIVE_ORDER_API_FAILURE:
      const { data: dataOrderAPIFailure } = state;
      dataOrderAPIFailure.order_api = 'NOT_RUNNING';
      return {
        ...state,
        isFetching: false,
        errorMessage: action.message,
        data: dataOrderAPIFailure,
      };
    default:
      return state;
  }
};

const results = combineReducers({
  selected,
});

export default results;
